import { routes } from '../domain/routes';
import { ActivationModeType } from '../boundries/signup';

export const activationMode: ActivationModeType = 'fd61387f';
export const signUpStartRoute = routes.signupTerms;
export const activationUserRedirection = '/signup/profile'; //only for basic
